const map = {
  success: 'Sucesso',
  canceled: 'Cancelada',
}

export default str => map[str] || str
